<script>
import { url, params } from '@sveltech/routify';

export let selectedRegionId;
</script>

<div id="api-type" class="tab">
  <a href={$url(`/view/?${$params.image_url ? `image_url=${encodeURIComponent($params.image_url)}&` : ''}type=search&region=${selectedRegionId}`)} class:active={$params.type === 'search'}>Search</a>
  <a href={$url(`/view/?${$params.image_url ? `image_url=${encodeURIComponent($params.image_url)}&` : ''}type=recommend&region=${selectedRegionId}`)} class:active={$params.type === 'recommend'}>Stylist</a>
  <a href={$url(`/view/?${$params.image_url ? `image_url=${encodeURIComponent($params.image_url)}&` : ''}type=recommend-pair&region=${selectedRegionId}`)} class:active={$params.type === 'recommend-pair'}>Stylist(pair)</a>
  <a href={$url(`/view/?${$params.image_url ? `image_url=${encodeURIComponent($params.image_url)}&` : ''}type=recommend-multi&region=${selectedRegionId}`)} class:active={$params.type === 'recommend-multi'}>Stylist(multi)</a>
</div>
